import { ReactNode } from "react"

export default function SectionHeader({
  icon,
  title,
  subtitle,
  children,
  action
}: {
  icon: ReactNode
  title: string
  subtitle?: string
  children?: ReactNode
  action?: ReactNode
}) {
  const content = (
    <div className="flex items-center gap-3">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#e6edf5] text-dantzBlue">
        {icon}
      </span>
      <div>
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
          {children}
        </div>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>
    </div>
  )

  if (!action) {
    return <div className="mb-6">{content}</div>
  }

  return (
    <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
      {content}
      <div className="shrink-0">{action}</div>
    </div>
  )
}
